import { Chip, ChipColor } from '@brunommsilva/react-foundations';
import { useTranslation } from 'react-i18next';

import { AccountType } from '../../models/accounts';
import { Bank, Cash, Investment, Savings } from '../icons';

export interface Props {
  type: AccountType;
}

const AccountTypeChip = ({ type }: Props) => {
  const { t } = useTranslation();

  const getChipColor = (): ChipColor => {
    switch (type) {
      case AccountType.SAVINGS:
        return 'green';
      case AccountType.BANK:
        return 'blue';
      case AccountType.CASH:
        return 'gray';
      case AccountType.INVESTMENT:
        return 'yellow';
      default:
        return;
    }
  };

  const getChipIcon = () => {
    switch (type) {
      case AccountType.SAVINGS:
        return <Savings />;
      case AccountType.BANK:
        return <Bank />;
      case AccountType.CASH:
        return <Cash />;
      case AccountType.INVESTMENT:
        return <Investment />;
      default:
        return;
    }
  };

  const getChipLabel = (): string => t(`ACCOUNT_TYPE_${type}`);

  const chipProps = {
    label: getChipLabel(),
    color: getChipColor(),
  };

  return (
    <Chip label={getChipLabel()} icon={getChipIcon()} color={chipProps.color} />
  );
};

export default AccountTypeChip;
